/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "CreateRiddleSourceEntryAPI",
            "endpoint": "https://0pawfsvt1a.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "GetResult",
            "endpoint": "https://f3dtih3bqe.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "batchList",
            "endpoint": "https://vgpqjs03lc.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "APIforUpdateRiddleSourceStatusLambda",
            "endpoint": "https://uz6i28d4ke.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:96eb9494-41ea-4c98-aa47-5ae9db78e1bb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vSqsJ2ruD",
    "aws_user_pools_web_client_id": "7u1bt3r20v613j7eaki9dkbhve",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "data-source-bucket09add-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
